<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchItem">
                            <el-input v-model="teamName" placeholder="单位/院校"></el-input>
                        </div>
                        <div class="searchItem">
                            <el-input v-model="code" placeholder="作品编号"></el-input>
                        </div>
                        <div class="searchItem">
                            <el-input v-model="worksName" placeholder="作品名称"></el-input>
                        </div>
                        <!--<div class="searchItem">
                            <el-select clearable v-model="status" placeholder="审批状态">
                                <el-option
                                    v-for="item in winType"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>-->
                        <div class="searchItem">
                            <el-select clearable v-model="scoreStatus" placeholder="评分状态">
                                <el-option label="已评分" value="TRUE">已评分</el-option>
                                <el-option label="未评分" value="FALSE">未评分</el-option>
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-select clearable
                                       @change="chooseActivityWayInfo"
                                       v-model="activityUuid" placeholder="活动名称">
                                <el-option
                                    v-for="item in activityList"
                                    :key="item.uuid"
                                    :label="item.activityName"
                                    :value="item.uuid">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-select clearable v-model="activityWayUuid"
                                       placeholder="赛道名称">
                                <el-option
                                    v-for="item in activityWayList"
                                    :key="item.uuid"
                                    :label="item.name"
                                    :value="item.uuid">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-input v-model="account" placeholder="账号"></el-input>
                        </div>
                        <div class="searchItem searchItem_time">
                            <!--<el-date-picker
                                v-model="createDate"
                                type="date"
                                placeholder="报名时间"
                            >
                            </el-date-picker>-->
                            <el-date-picker
                                @change="chooseDate"
                                style="width:320px"
                                v-model="createDate"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="报名开始日期"
                                end-placeholder="报名结束日期">
                            </el-date-picker>
                        </div>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <!-- 排序 -->
                    <div class="sorting">
                        <el-radio-group v-model="checkboxGroup.radio1" size="small">
                            <el-radio-button label="worksScore">
                                <div @click="findInfoBut('data')" class="flex">
                                    <p>得分</p>
                                    <i :class="deIcon"></i>
                                </div>
                                <!-- <i class="el-icon-bottom" v-if="checkboxGroup.radio1 == 'score'"></i>
                                <i class="el-icon-top" v-else></i> -->
                            </el-radio-button>
                            <el-radio-button label="createTime">
                                <div @click="findInfoBut('time')" class="flex">
                                    <p>时间</p>
                                    <i :class="deIcon2"></i>
                                </div>
                                <!-- <i class="el-icon-bottom" v-if="checkboxGroup.radio1 == 'createTime'"></i> -->
                                <!-- <i class="el-icon-top" v-else></i> -->
                            </el-radio-button>
                        </el-radio-group>
                       <!-- <span>已选： <span class="num">{{ num }}</span></span>-->
                        <el-button
                            type="primary"
                            plain
                            size="small"
                            @click="publishSubmit('')"
                        >批量导出</el-button>
                    </div>

                    <div class="orderListTable">
                        <!-- <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>添加
                                </el-button>
                            </div>
                        </div> -->
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <!--<el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>-->
                            <el-table-column
                                prop="signCreateTime"
                                label="报名时间"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <!--<el-table-column
                                prop="nickname"
                                label="昵称"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip>
                            </el-table-column>-->
                            <el-table-column
                                prop="username"
                                label="姓名"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="account"
                                align="center"
                                header-align="center"
                                label="账号">
                            </el-table-column>
                            <el-table-column
                                prop="signType"
                                align="center"
                                header-align="center"
                                label="参赛主体">
                                <template slot-scope="scope">
                                    {{ scope.row.signType==='PERSONAL'?'个人':'团队' }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="teamName"
                                align="center"
                                header-align="center"
                                label="单位/院校">
                            </el-table-column>
                            <el-table-column
                                prop="teamMember"
                                align="center"
                                header-align="center"
                                label="指导老师">
                            </el-table-column>
                            <el-table-column
                                prop="code"
                                align="center"
                                header-align="center"
                                label="作品编号">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                align="center"
                                header-align="center"
                                label="作品名称">
                            </el-table-column>
                            <el-table-column
                                prop="activityWayName"
                                align="center"
                                header-align="center"
                                label="赛道名称">
                            </el-table-column>
                            <el-table-column
                                prop="typeName"
                                align="center"
                                header-align="center"
                                label="作品类别">
                            </el-table-column>
                            <el-table-column
                                prop="voteScore"
                                align="center"
                                header-align="center"
                                label="投票得分">
                            </el-table-column>
                            <el-table-column
                                prop="score"
                                align="center"
                                header-align="center"
                                label="评委评分">
                                <template slot-scope="scope">
                                    {{ scope.row.activityStatus=='COLLECT'?'':scope.row.score==0?'评审中':scope.row.score }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="worksScore"
                                align="center"
                                header-align="center"
                                label="作品总分">
                                <template slot-scope="scope">
                                    {{ (scope.row.voteScore+scope.row.score).toFixed(2) }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="reviewStatus"
                                align="center"
                                header-align="center"
                                label="审批状态">
                                <template slot-scope="scope">
                                    {{ scope.row.reviewStatus===null?'':scope.row.reviewStatus==='SUBMIT'?'审批中':scope.row.reviewStatus==='PASS'?'审核通过':'未通过' }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="getWorksDetails(scope.row.uuid)">查看</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.reviewStatus === 'PASS'&&scope.row.joinUUid === null" @click="toSetAward(scope.row)">获奖</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.qualificationUrl" @click="toDownLoad(scope.row)">下载资质</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--查看-->
        <works-details-dialog ref="worksDetailsDialogRef"></works-details-dialog>

        <!-- 获奖 -->
        <el-dialog title="添加奖项设置" :visible.sync="dialogFormVisible" append-to-body>
            <el-form>
                <el-form-item label="奖项名称"  prop="awardUuid">
                    <el-select v-model="awardUuid" placeholder="奖项">
                        <el-option
                            v-for="(item,index) in awardList"
                            :key="index"
                            :label="item.awardName"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitAwardActivity">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getWorksList,exportWorksList,getActivityInfo,getAwardList,saveWorksAwardInfo,getActivityWayList } from '../../utils/interface';
// 查看
import worksDetailsDialog from './activeDialog/worksDetailsDialog'
export default {
    components: {worksDetailsDialog},
    data() {
        return {
            dialogFormVisible:false,
            num:0,
            teamName: '',
            account: '',
            code: '',
            worksName:'',
            scoreStatus:'',
            typeUuid:'',
            createDate:[],
            status:'PASS',
            // 筛选
            winType: [
                {
                    value:'PASS',
                    label:'审批通过',
                },
                {
                    value:'SUBMIT',
                    label:'审批中',
                },
                {
                    value:'REJECT',
                    label:'未通过',
                },
            ],
            worksStatus: [
                {
                    value:'1',
                    label:'个人',
                },
                {
                    value:'2',
                    label:'团队',
                },
            ],
            // 排序
            checkboxGroup: {
                radio1: '0',
            },
            tableData:[],
            current: 1,
            pageSize: 10,
            total: 0,
            activityUuid:'',
            activityList:[],
            activityWayUuid:'',
            activityWayList:[],
            awardList:[],
            awardUuid:"",
            worksUuid:"",
            orderBy:"",
            multipleSelection:[],
            // 时间区间
            startTime:"",
            endTime:"",
            deIcon: "el-icon-top",
            deIcon2: "el-icon-top",
        }
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120
            return {minHeight: height + 'px'}
        },
    },
    created() {
        this.activityUuid = this.$route.params.uuid;
        if(this.activityUuid!=undefined){
            this.chooseActivityWayInfo();
        }
        this.getList();
        getActivityInfo({activityStatus:"PREPARE,COLLECT,EVALUATE,FINISHED"}).then((res)=>{
            this.activityList = res;
        });
    },
    methods: {
        // 查询赛道信息
        chooseActivityWayInfo(){
            this.activityWayUuid = "";
            this.activityWayList = [];
            getActivityWayList({activityUuid:this.activityUuid}).then((res)=>{
                this.activityWayList = res;
            });
        },
        getList(){
            //let year = this.createDate==null?null:this.createDate.getFullYear();
            //let month = this.createDate==null?null:this.createDate.getMonth() < 10?'0'+(this.createDate.getMonth() + 1):this.createDate.getMonth() + 1;
            //let date = this.createDate==null?null:this.createDate.getDate() < 10?'0'+this.createDate.getDate():this.createDate.getDate();
            let params = {
                teamName:this.teamName,
                name:this.worksName,
                code:this.code,
                account:this.account,
                status:this.status,
                activityUuid:this.activityUuid,
                activityWayUuid:this.activityWayUuid,
                orderBy:this.orderBy,
                signStartDate:this.startTime,
                signEndDate:this.endTime,
                scoreStatus:this.scoreStatus,
                current:this.current,
                pageSize:this.pageSize,
            };
            console.log("this.orderBy",this.orderBy)
            getWorksList(params).then((res)=>{
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        resetData(){
            this.account = "";
            this.createDate = [];
            this.teamName = '';
            this.worksName = '';
            this.code = '';
            this.activityUuid = "";
            this.activityWayUuid = "";
            this.orderBy = '';
            this.startTime = "";
            this.endTime = "";
            this.scoreStatus = "";
            this.search();
        },
        findInfoBut(type){
            if(type == 'data'){
                if(this.deIcon == "el-icon-top") {
                    this.deIcon = "el-icon-bottom"
                    this.deIcon2 = "el-icon-top"
                    this.orderBy = "worksScore_descend";
                }else {
                    this.deIcon = "el-icon-top"
                    this.orderBy = "worksScore_ascend";
                }
            }else if (type == 'time'){
                if(this.deIcon2 == "el-icon-top") {
                    this.deIcon2 = "el-icon-bottom"
                    this.deIcon = "el-icon-top"
                    this.orderBy = "createTime_descend";
                }else {
                    this.deIcon2 = "el-icon-top"
                    this.orderBy = "createTime_ascend";
                }
            }
            this.search();
        },
        // findInfo() {
        //     if(this.deIcon == "el-icon-top") {
        //         this.deIcon = "el-icon-bottom"
        //     }else {
        //         this.deIcon = "el-icon-top"
        //     }
        //     if(this.deIcon2 == "el-icon-top") {
        //         this.deIcon2 = "el-icon-bottom"
        //     }else {
        //         this.deIcon2 = "el-icon-top"
        //     }
        //     this.search();
        // },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getList();
        },
        search(){
           this.current = 1;
           this.getList();
        },
        // // 查看
        getWorksDetails(uuid){
            this.$refs.worksDetailsDialogRef.init(uuid)
        },
        // 获奖
        toSetAward(item){
            this.worksUuid = item.uuid;
            this.dialogFormVisible = true;
            this.awardUuid = "";
            // 获取奖项
            getAwardList({activityWayUuid:item.activityWayUuid}).then((res)=>{
                this.awardList = res;
            });
        },
        toDownLoad(item) {
            const x = new window.XMLHttpRequest();
            x.open('GET', item.qualificationUrl, true);
            x.responseType = "blob";
            x.onload = () =>{
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = item.qualificationName;
                a.click();
            };
            x.send();
        },
        submitAwardActivity(){
            saveWorksAwardInfo(this.worksUuid,this.awardUuid).then((res)=>{
                if(res.success){
                    this.$message.success("设置成功");
                    this.dialogFormVisible = false;
                    this.getList();
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.num = this.multipleSelection.length;
        },
        // 导出
        publishSubmit(){
            /*if(this.multipleSelection.length==0){
                this.$message.error("请选择要导出的数据");
                return
            }*/
            let params = {
                teamName:this.teamName,
                name:this.worksName,
                code:this.code,
                account:this.account,
                status:this.status,
                activityUuid:this.activityUuid,
                activityWayUuid:this.activityWayUuid,
                orderBy:this.orderBy,
                signStartDate:this.startTime,
                signEndDate:this.endTime,
                scoreStatus:this.scoreStatus,
                current:this.current,
                pageSize:this.pageSize,
            };
            exportWorksList(params).then((resp)=>{
                let items=[];
                resp.forEach((item, index) => {
                    let it = {...item};
                    it.signTypes = it.signType==='PERSONAL'?'个人':'团队';
                    it.worksScore = it.voteScore+it.score;
                    it.reviewStatus = it.reviewStatus===null?'':it.reviewStatus==='SUBMIT'?'审批中':it.reviewStatus==='PASS'?'审核通过':'未通过'
                    items.push(it);
                });
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../../static/js/Export2Excel');//注意这个Export2Excel路径
                    const tHeader = ['报名时间', '姓名', '账号', '联系方式', '参赛主体', '单位/院校',
                        '指导老师', '赛道名称', '作品编号','作品名称', '作品类别', '投票数量', '投票得分',
                        '评委评分', '作品总分', '审批状态' ];   // 上面设置Excel的表格第一行的标题
                    const filterVal = ['createTime', 'username', 'account', 'tel','signTypes', 'teamName',
                        'teamMember', 'activityWayName', 'code','name', 'typeName', 'voteNum', 'voteScore',
                        'score', 'worksScore', 'reviewStatus']; // 上面的index、nickName、name是tableData里对象的属性key值
                    // const list = this.multipleSelection;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, items);
                    export_json_to_excel(tHeader, data, '活动作品管理');//最后一个是表名字
                })
            });

        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.createDate!=null && this.createDate.length==2){
                this.startTime = this.timeDate(this.createDate[0]);
                this.endTime = this.timeDate(this.createDate[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        }
    }
}
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 20px;

                    /deep/ .el-input {
                        width: initial;
                        // margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                    .searchItem {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                      .name {
                          padding-right: 20px;
                          min-width: 100px;
                      }
                    }
                    .searchItem_time {
                      margin-right: 30px;
                      /deep/.el-input__inner {
                        width: 292px;
                      }
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
                .orderListTable {
                    margin-top: 35px;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .sorting {
        p {
            margin: 0;
        }
        /deep/.el-radio-button--small .el-radio-button__inner {
           display: flex;
           align-items: center;
        }
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            background-color: #3d7fff;
        }
    }
    .flex {
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/worksManagementList.vue